import * as yup from "yup";

export const UserUpdateSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .required("First name is required")
    .test("len", "First name must be 48 characters max.", (val) => (val?.toString().length || 0) <= 48)
    .test("firstName", "First name is not valid", (value) => {
      return value ? /^[a-zA-Z ]*$/.test(value) : false;
    }),
  lastName: yup
    .string()
    .trim()
    .required("Last name is required")
    .test("len", "Last name must be 48      characters max.", (val) => (val?.toString().length || 0) <= 48)
    .test("lastName", "Last name is not valid", (value) => {
      return value ? /^[a-zA-Z ]*$/.test(value) : false;
    }),

  phone: yup.string().required("Phone number is a required field").min(12, "Phone must be at least 10 character "),
  isEnablePhoneLogin: yup.boolean()
    .optional(),
  otp: yup.string().optional().nullable(),
  email: yup.string().email(),
  location: yup.string().required(),
  placeId: yup.string().nullable(),
  streetAddress: yup.string().nullable(),
  address: yup.string().nullable(),
  townCity: yup.string().nullable(),
  zipCode: yup.string().test("valid-zip-code", "Invalid zip code", function(value) {
    if (value === null || value === undefined || value === "") {
      return true;
    }

    return /^\d{5}(-\d{4})?$/.test(value);
  }),
  country: yup.string().nullable(),
});

export const UserReviewSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .required("First name is required")
    .test("len", "First name must be 48 characters max.", (val) => (val?.toString().length || 0) <= 48)
    .test("firstName", "First name is not valid", (value) => {
      return value ? /^[a-zA-Z ]*$/.test(value) : false;
    }),
  lastName: yup
    .string()
    .trim()
    .required("Last name is required")
    .test("len", "Last name must be 48 characters max.", (val) => (val?.toString().length || 0) <= 48)
    .test("lastName", "Last name is not valid", (value) => {
      return value ? /^[a-zA-Z ]*$/.test(value) : false;
    }),
  countryCode: yup
    .string()
    .required("Country code is required"),
  phone: yup.string()
    .required("Mobile number is required")
    .min(12, "Mobile number is not valid format"),
  location: yup.string().required(),
  placeId: yup.string().nullable(),
  streetAddress: yup.string().nullable(),
  address: yup.string().nullable(),
  townCity: yup.string().nullable(),
  zipCode: yup.string().nullable(),
  country: yup.string().nullable(),
});

export const UserUpdateLocationSchema = yup.object({
  location: yup.string().required(),
});

export type UserUpdateFormType = yup.InferType<typeof UserUpdateSchema>;
export type UserReviewFormType = yup.InferType<typeof UserReviewSchema>;
export type UserUpdateLocationFormType = yup.InferType<typeof UserUpdateLocationSchema>;
